export const lineColors = ['#497dff', '#c79833', '#dd544c', '#1c3e92', '#e5e44c']